import React from 'react';
import {
  TempBadgeStatus,
  useGetTempBadgesQuery,
} from 'apollo/generated/client-operations';
import { SelectOptionElement } from '@odin-labs/components';

export type TempBadgeOptionElement = SelectOptionElement & {
  workerCardFormatId: string;
};

export function useTempBadgeOptions(
  jobsiteId: string,
): TempBadgeOptionElement[] {
  const { data } = useGetTempBadgesQuery({
    fetchPolicy: 'no-cache',
    skip: !jobsiteId,
    variables: {
      jobsiteId,
      jobsiteTempBadgesInput: {
        statuses: [TempBadgeStatus.Registered],
      },
    },
  });

  return React.useMemo((): TempBadgeOptionElement[] => {
    return (
      data?.getJobsite.tempBadges.edges
        .map(({ node: tb }) => ({
          value: tb.id,
          label: `${tb.name} (#${tb.cardNumber})`,
          workerCardFormatId:
            tb.jobsiteCardFormat.workerCardFormat.workerCardFormatId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) ?? []
    );
  }, [data]);
}
